















































































































































































































































import Vue from 'vue'
import api from '../../../api'
import CreditReimbursementsModal from '../components/CreditReimbursementsModal.vue'

export default Vue.extend({
  components: {
    CreditReimbursementsModal
  },

  data() {
    return {
      loading: false,
      error: null as string | null,
      beneficiary: null as any,
      showReimbursementsModal: false,
      selectedCredit: null as any
    }
  },

  computed: {
    beneficiaryId(): string {
      return this.$route.params.beneficiaryId
    }
  },

  methods: {
    formatAmount(amount: number): string {
      return new Intl.NumberFormat('fr-FR').format(amount)
    },

    formatDate(date: string): string {
      return new Date(date).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    getStateLabel(state: string): string {
      const labels: Record<string, string> = {
        succeeded: 'Succès',
        failed: 'Échec',
        pending: 'En attente',
        created: 'Créé'
      }
      return labels[state] || state
    },

    getStateBgColor(state: string): string {
      const colors: Record<string, string> = {
        succeeded: '#dcfce7',
        failed: '#fee2e2',
        pending: '#fed7aa',
        created: '#dbeafe'
      }
      return colors[state] || '#f3f4f6'
    },

    getStateTextColor(state: string): string {
      const colors: Record<string, string> = {
        succeeded: '#15803d',
        failed: '#b91c1c',
        pending: '#c2410c',
        created: '#1d4ed8'
      }
      return colors[state] || '#374151'
    },

    async loadBeneficiaryDetails() {
      this.loading = true
      this.error = null

      try {
        const response = await api.get(`/beneficiaries/${this.beneficiaryId}`)
        this.beneficiary = response.data
      } catch (err) {
        console.error('Error loading beneficiary details:', err)
        this.error =
          err.response?.data?.message ||
          'Erreur lors du chargement des informations du bénéficiaire'
      } finally {
        this.loading = false
      }
    },

    viewCreditReimbursements(credit: any) {
      this.selectedCredit = credit
      this.showReimbursementsModal = true
    }
  },

  async created() {
    await this.loadBeneficiaryDetails()
  }
})
